export default "__VITE_ASSET__Dk4Wi8wI__"